import { render } from "./seniorAuth.vue?vue&type=template&id=67b9aea2&scoped=true"
import script from "./seniorAuth.vue?vue&type=script&lang=js"
export * from "./seniorAuth.vue?vue&type=script&lang=js"

import "./seniorAuth.vue?vue&type=style&index=0&id=67b9aea2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b9aea2"]])

export default __exports__